// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TOyS","col":"styles_col__ywjo9"};